import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_viverdetrade.png",
      alt: "Estratégias Viver de Trade",
    },
    title: "VDT Invest",

    // String ou array de strings
    text: "Investir em Ações nunca foi fácil. Agora é!",
    testimonial: {
      text: [
        "A VDT invest traz um novo conceito. Liberdade. E isso é o melhor. Você escolhe onde investir. Sem necessidade de ficar analisando os gráficos.",
        "Pioneiro em operações de Swing Trade, O Algoritmo VDT invest faz, diariamente, a análise de todas as ações do IBRA e traz as 50 melhores ações para você escolher em qual investir.",
        "Com gestão de capital inteligente e rigoroso controle de risco, a missão da VDT invest é valorizar seu capital, de forma responsável e consistente.",
      ],
      author: {
        // name: "Raphael B.M., Head de Estratégias e Professor no QG DO TRADER",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },

  strategies: {
    title: "Estratégia VDT Invest",
    heading: "Uma nova maneira de investir em Ações",
    subtitle: [
      "Diferente dos tradicionais modelos de investimentos, você escolhe, a partir de uma lista de 50 ações, em quais delas deseja investir, de acordo com seu plano.",
      "No melhor momento, o algoritmo VDT invest envia o sinal para sua conta da XP, através das corretoras BS/Investimentos e BRA e a operação é realizada automaticamente. As operações são somente de compra.",
      "Em todas as operações, o limite de segurança para aporte é de R$ 5.000,00, permitindo diversificação de ações e setores, bem como minimiza os riscos da operação.",
      "Sem interferência. Sem fatores psicológicos, deixando a estatística trabalhar a seu favor. Todas as operações são realizadas a partir do gráfico diário, com risco admitido de 5% e busca de retorno de 10%. Sem alavancagem, o que traz maior segurança para o investidor.",
    ],
  },

  cta: {
    title: "Nunca foi fácil investir em ações. Agora é.",
    subtitle: "Comece agora a multiplicar seu capital com VDT Invest!",
  },

  about: {
    title: "Sobre a empresa",
    subtitle: "A Viver de Trade",
    col1: [
      "Com a proposta de democratizar o mercado financeiro e as operações de Day Trade e Swing Trade, com a proposta de valorizar seu capital de forma responsável e consistente, nasceu a Viver de Trade Educação.",
      "Através de padrões gráficos, aliado a indicadores técnicos e, observando o ciclo do mercado e a tendência de cada ação individualmente, o algoritmo VDT invest faz a análise de todas as ações que compõem o IBRA - formado por 201 ações e busca sempre iniciar a operação de compra em Swing Trade no início da pernada de valorização, buscando o retorno nos primeiros movimentos, aumentando assim a probabilidade de retorno e reduzindo o risco em cada operação.",
    ],
    col2: [
      "Formada por uma equipe de analistas gráficos e programadores, a Viver de Trade Educação tem hoje no mercado, diversos algoritmos, que atendem desde operações mais rápidas - os scalps - até operações de médio e longo prazos, todas de forma automatizada.",
    ],
  },

  stats: {
    title: "Números VDT Invest",
    subtitle: "Experiência e base estatística para busca de resultados",
    data: [
      {
        value: "+450",
        description: "ativos analisados",
      },
      {
        value: "+5k",
        description: "clientes",
      },
      {
        value: "+89%",
        description: "ações com resultado positivo no longo prazo",
      },
    ],
  },

  features: {
    type: 1,
    title: "Por quê utilizar o algoritmo automatizado VDT Invest?",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.tour,
        title: "Pioneiro",
        description:
          "Inédito robô para Operações de Swing Trade, busca ativos em tendência de alta, no melhor ponto para o início de uma pernada de valorização.",
      },
      {
        icon: iconsSet.calendar,
        title: "Histórico",
        description:
          "Utiliza a estatística de longo prazo para encontrar as melhores oportunidades.",
      },
      {
        icon: iconsSet.open_lock,
        title: "Liberdade",
        description: "Você escolhe as ações as quais seu capital vai operar.",
      },
      {
        icon: iconsSet.code,
        title: "100% Automatizado",
        description:
          "O algoritmo faz as análises e, no melhor ponto, envia o sinal para sua conta XP através da BS/Investimentos ou BRA e a operação é iniciada ao atingir o ponto de ativação. Não temos acesso à sua conta. Não temos acesso a seus dados. Enviamos apenas o sinal para sua corretora. É ela quem coloca a ordem de compra. Sua conta está protegida por todas as camadas de segurança.",
      },
      {
        icon: iconsSet.balance,
        title: "Gestão Inteligente",
        description:
          "Realiza operações de compra apenas em ações em tendência de alta, gerenciando o capital e o risco, com limite de R$5.000,00 por operação, buscando 10% de alvo com risco de 5%, permitindo diversificação de ações e setores, com risco moderado.",
      },
      {
        icon: iconsSet.pie_chart_2,
        title: "Estatística",
        description:
          "Expectativa matemática positiva a longo prazo. Estudos realizados em todas as ações do IBRA, entre 2018 e 2022, mostraram retorno positivo em 89,56% das ações.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos VDT Invest.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
